var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallGetHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.45 14.1667C15.5 14.9083 15.625 15.6333 15.825 16.325L14.825 17.325C14.4833 16.325 14.2667 15.2667 14.1917 14.1667H15.45ZM23.6667 24.1833C24.375 24.3833 25.1 24.5083 25.8333 24.5583V25.8C24.7333 25.725 23.675 25.5083 22.6667 25.175L23.6667 24.1833ZM16.25 12.5H13.3333C12.875 12.5 12.5 12.875 12.5 13.3333C12.5 21.1583 18.8417 27.5 26.6667 27.5C27.125 27.5 27.5 27.125 27.5 26.6667V23.7583C27.5 23.3 27.125 22.925 26.6667 22.925C25.6333 22.925 24.625 22.7583 23.6917 22.45C23.6083 22.4167 23.5167 22.4083 23.4333 22.4083C23.2167 22.4083 23.0083 22.4917 22.8417 22.65L21.0083 24.4833C18.65 23.275 16.7167 21.35 15.5167 18.9917L17.35 17.1583C17.5833 16.925 17.65 16.6 17.5583 16.3083C17.25 15.375 17.0833 14.375 17.0833 13.3333C17.0833 12.875 16.7083 12.5 16.25 12.5Z",
    fill: "#32363E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGetHelp);
export default __webpack_public_path__ + "static/media/CallGetHelp.bcd54cde21744cfb45e95da906569798.svg";
export { ForwardRef as ReactComponent };